(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8813],{

/***/ 49600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77848)


/***/ }),

/***/ 28901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Influencer = {};
var influencerProps = {
  name: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].object.isRequired,
  url: _propTypes["default"].string.isRequired,
  username: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string
};
Influencer.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, influencerProps[prop]));
  }, {})) : _propTypes["default"].shape(influencerProps);
};
var _default = Influencer;
exports["default"] = _default;

/***/ }),

/***/ 44997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Influencer = _interopRequireDefault(__webpack_require__(28901));
var __jsx = _react["default"].createElement;
var ArticleHeader = function ArticleHeader(props) {
  var influencerData = props.influencerData,
    title = props.title,
    subtitle = props.subtitle;
  var _ref = influencerData || {},
    image = _ref.image,
    name = _ref.name,
    url = _ref.url,
    username = _ref.username;
  var translations = {
    storyWith: (0, _langLibrary["default"])("Story with"),
    from: (0, _langLibrary["default"])("from")
  };
  var influencerInfo = __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      width: 60,
      height: 60,
      borderRadius: 60,
      mb: "s4",
      overflow: "hidden"
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1
    },
    minified: true,
    image: image
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s",
      color: "main"
    }
  }, translations.storyWith), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      font: "s",
      mb: "s8",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "s_italic"
    }
  }, name), "\xA0", translations.from, "\xA0", __jsx(_Box["default"], {
    sx: {
      font: "s_italic",
      color: "main"
    }
  }, __jsx(_LinkRaw["default"], {
    href: url,
    target: "_blank",
    title: name
  }, " @" + username))));
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      my: "s8"
    }
  }, subtitle && __jsx(_Box["default"], {
    as: "h4",
    sx: {
      font: "label2",
      mb: "s8",
      color: "main"
    }
  }, subtitle), __jsx(_Box["default"], {
    sx: {
      mb: "s11",
      font: "heading2",
      textAlign: "center",
      width: "80%",
      color: "main"
    }
  }, title), influencerData && influencerInfo);
};
var _default = ArticleHeader;
exports.Z = _default;

/***/ }),

/***/ 53680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _ScrollableStack = _interopRequireDefault(__webpack_require__(50902));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Theme = __webpack_require__(86522);
var _useHover = _interopRequireDefault(__webpack_require__(68854));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var defaultProps = {
  titleAs: "h3"
};
var CardsSlider = function CardsSlider(props) {
  var children = props.children,
    title = props.title,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    itemsVisible = props.itemsVisible,
    itemsGap = props.itemsGap,
    buttonArrowLeft = props.buttonArrowLeft,
    buttonArrowRight = props.buttonArrowRight;
  var theme = (0, _Theme.useTheme)();
  var gap = itemsGap ? itemsGap : theme.space.gridGap;
  var margin = theme.space.containerMargin;
  var rootRef = (0, _react.useRef)(null);
  var rootHovered = (0, _useHover["default"])(rootRef);
  return __jsx(_Box["default"], {
    _ref: rootRef
  }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
    as: titleAs,
    sx: {
      font: "label",
      mb: "s8"
    }
  }, title)), __jsx(_Container["default"], {
    margin: [0, null, "containerMargin"]
  }, __jsx(_ScrollableStack["default"], {
    sx: {
      width: "100%",
      $itemsVisible: itemsVisible ? itemsVisible : [1.5, null, 3, null, 4],
      $gap: gap,
      $innerMargin: [margin[0], null, 0] // TODO: in commerce-ui update we'll allow for ["containerMargin", null, 0] syntax.
    },
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowLeft, {
          sx: {
            opacity: !rootHovered || isAtStart ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: !rootHovered || isAtStart ? "none" : "default"
          }
        }),
        offset: -22
      };
    },
    nextButton: function nextButton(_ref2) {
      var isAtEnd = _ref2.isAtEnd;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowRight, {
          sx: {
            opacity: !rootHovered || isAtEnd ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: !rootHovered || isAtEnd ? "none" : "default"
          }
        }),
        offset: -22
      };
    }
  }, children)));
};
var _default = CardsSlider;
exports.Z = _default;

/***/ }),

/***/ 11316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Influencer = _interopRequireDefault(__webpack_require__(28901));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var __jsx = _react["default"].createElement;
var InfluencerBio = function InfluencerBio(props) {
  var _props$influencerData = props.influencerData,
    image = _props$influencerData.image,
    name = _props$influencerData.name,
    url = _props$influencerData.url,
    username = _props$influencerData.username,
    description = _props$influencerData.description;
  return __jsx(_Box["default"], {
    sx: {
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderTopColor: "neutral500",
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: "neutral500",
      pt: "s9",
      pb: "s9",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "80px",
      height: "80px",
      borderRadius: "80px",
      overflow: "hidden"
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1
    },
    minified: true,
    image: image
  })), __jsx(_Box["default"], {
    sx: {
      ml: "s8",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s"
    }
  }, name), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s_italic"
    }
  }, __jsx(_LinkRaw["default"], {
    href: url,
    target: "_blank",
    title: name
  }, "@" + username)))), __jsx(_Box["default"], {
    sx: {
      font: "base",
      mt: "s9"
    }
  }, description));
};
var _default = InfluencerBio;
exports.Z = _default;

/***/ }),

/***/ 36880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Op = exports.ZP = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _head = _interopRequireDefault(__webpack_require__(49600));
var _router = __webpack_require__(53746);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _LanguageProvider = __webpack_require__(8989);
var _useSalesmanago = _interopRequireDefault(__webpack_require__(54569));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var META_TYPE = {
  searchResults: "product-search",
  productPage: "product-page",
  categoryPage: "category-page, product-list"
};
exports.Op = META_TYPE;
Object.freeze(META_TYPE);
var defaultProps = {
  siteName: "Dajar"
};
var MetaTags = function MetaTags(props) {
  var page = props.page,
    sku = props.sku,
    passedUrl = props.url,
    productRegularPrice = props.productRegularPrice,
    productSpecialPrice = props.productSpecialPrice,
    productAvailability = props.productAvailability,
    productBrand = props.productBrand,
    productCategory = props.productCategory,
    currentPageNumber = props.currentPageNumber,
    tags = props.tags,
    noFollow = props.noFollow,
    domains = props.domains,
    _props$siteName = props.siteName,
    siteName = _props$siteName === void 0 ? defaultProps.siteName : _props$siteName;
  var translations = {
    page: (0, _langLibrary["default"])("page")
  };
  var singleDomain = props.singleDomain,
    title = props.title,
    description = props.description,
    imageUrl = props.imageUrl;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  singleDomain = singleDomain ? "https://".concat(singleDomain) : null;
  var baseUrl = domains ? "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  })) : singleDomain;
  var router = (0, _router.useRouter)();
  var routePaths = router !== null && router !== void 0 && router.asPath ? router.asPath.split("?") : [];
  var defaultOgImage = "/static/images/dajar-og-image.jpg";
  if (currentPageNumber) {
    title += "| ".concat(translations.page, " ").concat(currentPageNumber);
  }
  var tagsPrefix = tags && tags.length > 3 ? tags.join(", ") + "... - " : tags && tags.length > 0 ? tags.join(", ") + " - " : "";
  title = tagsPrefix + title;
  description = tagsPrefix + description;
  var url = noFollow ? baseUrl + passedUrl : baseUrl + "".concat(routePaths[0]);
  imageUrl = imageUrl === undefined || page === META_TYPE.searchResults ? baseUrl + defaultOgImage : baseUrl + imageUrl;
  (0, _react.useEffect)(function () {
    handleSalesmanagoEvent("VISIT");
  }, [title]);
  if (title !== "undefined") {
    return __jsx(_head["default"], null, __jsx("title", null, title), __jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), __jsx("meta", {
      name: "robots",
      content: page === META_TYPE.searchResults || noFollow ? "noindex, nofollow" : "index, follow"
    }), __jsx("link", {
      rel: "canonical",
      href: url
    }), __jsx("meta", {
      name: "title",
      content: title
    }), __jsx("meta", {
      name: "description",
      content: description
    }), __jsx("meta", {
      property: "og:site_name",
      content: siteName
    }), __jsx("meta", {
      property: "og:locale",
      content: language === null || language === void 0 ? void 0 : language.language
    }), __jsx("meta", {
      property: "og:title",
      content: title
    }), __jsx("meta", {
      property: "og:description",
      content: description
    }), __jsx("meta", {
      property: "og:type",
      content: page === META_TYPE.productPage ? "product" : "website"
    }), __jsx("meta", {
      property: "og:url",
      content: url
    }), __jsx("meta", {
      property: "og:image",
      content: imageUrl
    }), __jsx("meta", {
      property: "og:image:alt",
      content: title
    }), page === META_TYPE.productPage && __jsx(_react["default"].Fragment, null, __jsx("meta", {
      property: "product:condition",
      content: "new"
    }), __jsx("meta", {
      property: "product:availability",
      content: productAvailability
    }), __jsx("meta", {
      property: "product:original_price:amount",
      content: productRegularPrice
    }), __jsx("meta", {
      property: "product:original_price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:price:amount",
      content: productSpecialPrice
    }), __jsx("meta", {
      property: "product:price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:retailer_item_id",
      content: sku
    }), __jsx("meta", {
      property: "product:brand",
      content: productBrand
    }), __jsx("meta", {
      property: "product:category",
      content: productCategory
    })), __jsx("meta", {
      property: "twitter:card",
      content: page === META_TYPE.productPage ? "product" : "summary_large_image"
    }), __jsx("meta", {
      property: "twitter:site",
      content: "@DAJARpl"
    }), __jsx("meta", {
      property: "twitter:url",
      content: url
    }), __jsx("meta", {
      property: "twitter:title",
      content: title
    }), __jsx("meta", {
      property: "twitter:description",
      content: description.slice(0, 100)
    }), __jsx("meta", {
      property: "twitter:image",
      content: imageUrl
    }));
  } else {
    return __jsx(_head["default"], null);
  }
};
var _default = MetaTags;
exports.ZP = _default;

/***/ }),

/***/ 18799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
var ArrowMoreIcon = function ArrowMoreIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }));
};
ArrowMoreIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var RelatedStory = function RelatedStory(props) {
  var title = props.title,
    description = props.description,
    route = props.route,
    image = props.image;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Grid["default"], {
    cols: [4, null, 10, null]
  }, __jsx(_Box["default"], {
    sx: {
      gridColumn: ["span 2", null, "span 3", null]
    }
  }, __jsx(Link, {
    route: "article",
    params: {
      url: "article/" + route
    }
  }, __jsx(_LinkRaw["default"], {
    title: title
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1,
      objectFit: "cover",
      width: "100%",
      cursor: "pointer"
    },
    image: image,
    overlay: true,
    sizes: "(max-width: 720px) and (min-width: 495px) 420px, 210px"
  })))), __jsx(_Box["default"], {
    sx: {
      color: "main",
      gridColumn: ["span 2", null, "span 5", null]
    }
  }, __jsx(_Box["default"], {
    as: "h5",
    sx: {
      font: "heading3",
      py: "s5"
    }
  }, title), __jsx(_Box["default"], {
    as: "p",
    sx: {
      mb: "s7"
    }
  }, description), __jsx(Link, {
    route: "article",
    params: {
      url: "article/" + route
    }
  }, __jsx(_LinkRaw["default"], {
    title: title,
    sx: {
      cursor: "pointer"
    }
  }, __jsx(ArrowMoreIcon, null)))));
};
var _default = RelatedStory;
exports.Z = _default;

/***/ }),

/***/ 50444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ButtonAmbitionBack = exports.ButtonArrowAmbitionRight = exports.ButtonArrowAmbitionLeft = exports.ButtonArrowProRight = exports.ButtonArrowProLeft = exports.ButtonArrowBigRight = exports.ButtonArrowBigLeft = exports.ButtonArrowRight = exports.ButtonArrowLeft = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _ButtonIcon = _interopRequireDefault(__webpack_require__(7859));
var _core = __webpack_require__(79329);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconChevronLeft = function IconChevronLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.952 12.748l8.133-8.495-.866-.83-8.92 9.316 8.915 9.51.876-.821-8.138-8.68z"
  }));
};
IconChevronLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconChevronRight = function IconChevronRight(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.436 12.748L7.303 4.253l.867-.83 8.92 9.316-8.916 9.51-.875-.821 8.137-8.68z"
  }));
};
IconChevronRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconArrowLeft = function IconArrowLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }));
};
IconArrowLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var IconArrowRight = function IconArrowRight(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
  }));
};
IconArrowRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var sharedStyles = {
  overflow: "hidden",
  borderRadius: "22px",
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.15)",
  ":focus": {
    outline: 0
  },
  "::-moz-focus-inner": {
    border: 0
  },
  $background: function $background(_ref) {
    var isHovered = _ref.isHovered;
    return {
      bg: "white",
      opacity: 1,
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
};
var ButtonArrow = (0, _core.createComponent)(_ButtonIcon["default"], _objectSpread({
  height: "44px",
  width: "44px"
}, sharedStyles));
var ButtonArrowPro = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "42px",
  width: "42px",
  overflow: "hidden",
  borderRadius: "22px",
  boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.3)",
  ":focus": {
    outline: 0
  },
  "::-moz-focus-inner": {
    border: 0
  },
  $background: function $background(_ref2) {
    var isHovered = _ref2.isHovered;
    return {
      bg: isHovered ? "mono200" : "white",
      opacity: 1,
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
});
var ButtonArrowAmbition = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "40px",
  width: "40px",
  overflow: "hidden",
  borderRadius: "22px",
  $background: function $background(_ref3) {
    var isHovered = _ref3.isHovered;
    return {
      bg: isHovered ? "main" : "darkGrey",
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "white"
  }
});
var ButtonArrowBack = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "40px",
  pl: "16px",
  pr: "24px",
  overflow: "hidden",
  borderRadius: "60px",
  $background: function $background(_ref4) {
    var isHovered = _ref4.isHovered;
    return {
      bg: isHovered ? "veryLightGray" : "grayBg",
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
});
var ButtonArrowBig = (0, _core.createComponent)(_ButtonIcon["default"], _objectSpread(_objectSpread({
  height: "55px",
  width: "55px"
}, sharedStyles), {}, {
  borderRadius: "55px"
}));
var ButtonArrowLeft = function ButtonArrowLeft(props) {
  return __jsx(ButtonArrow, props, __jsx(IconChevronLeft, null));
};
exports.ButtonArrowLeft = ButtonArrowLeft;
var ButtonArrowRight = function ButtonArrowRight(props) {
  return __jsx(ButtonArrow, props, __jsx(IconChevronRight, null));
};
exports.ButtonArrowRight = ButtonArrowRight;
var ButtonArrowBigLeft = function ButtonArrowBigLeft(props) {
  return __jsx(ButtonArrowBig, props, __jsx(IconChevronLeft, null));
};
exports.ButtonArrowBigLeft = ButtonArrowBigLeft;
var ButtonArrowBigRight = function ButtonArrowBigRight(props) {
  return __jsx(ButtonArrowBig, props, __jsx(IconChevronRight, null));
};
exports.ButtonArrowBigRight = ButtonArrowBigRight;
var ButtonArrowProLeft = function ButtonArrowProLeft(props) {
  return __jsx(ButtonArrowPro, props, __jsx(IconArrowLeft, null));
};
exports.ButtonArrowProLeft = ButtonArrowProLeft;
var ButtonArrowProRight = function ButtonArrowProRight(props) {
  return __jsx(ButtonArrowPro, props, __jsx(IconArrowRight, null));
};
exports.ButtonArrowProRight = ButtonArrowProRight;
var ButtonArrowAmbitionLeft = function ButtonArrowAmbitionLeft(props) {
  return __jsx(ButtonArrowAmbition, props, __jsx(IconArrowLeft, null));
};
exports.ButtonArrowAmbitionLeft = ButtonArrowAmbitionLeft;
var ButtonArrowAmbitionRight = function ButtonArrowAmbitionRight(props) {
  return __jsx(ButtonArrowAmbition, props, __jsx(IconArrowRight, null));
};
exports.ButtonArrowAmbitionRight = ButtonArrowAmbitionRight;
var ButtonAmbitionBack = function ButtonAmbitionBack(props) {
  return __jsx(ButtonArrowBack, props, __jsx(IconArrowLeft, null), props.children);
};
exports.ButtonAmbitionBack = ButtonAmbitionBack;

/***/ }),

/***/ 66836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var __jsx = _react["default"].createElement;
var Grid2Cards = function Grid2Cards(props) {
  var children = props.children;
  return __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: [1, 1, 2, 2, 2]
  }, children));
};
var _default = Grid2Cards;
exports.Z = _default;

/***/ }),

/***/ 88778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _Container = _interopRequireDefault(__webpack_require__(58709));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  titleAs: "h3",
  centeredTitle: true,
  headerFont: "xxl",
  headerIndent: 0,
  descriptionFont: "base_sans_bold",
  withBorder: true,
  titleColor: "main",
  descriptionColor: "main",
  bottomBorderColor: "main",
  noSpaceAfterHeader: false,
  withContainer: false
};
var SectionWithConfigurableHeader = function SectionWithConfigurableHeader(props) {
  var title = props.title,
    link = props.link,
    children = props.children,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    _props$centeredTitle = props.centeredTitle,
    centeredTitle = _props$centeredTitle === void 0 ? defaultProps.centeredTitle : _props$centeredTitle,
    description = props.description,
    _props$headerFont = props.headerFont,
    headerFont = _props$headerFont === void 0 ? defaultProps.headerFont : _props$headerFont,
    _props$headerIndent = props.headerIndent,
    headerIndent = _props$headerIndent === void 0 ? defaultProps.headerIndent : _props$headerIndent,
    _props$noSpaceAfterHe = props.noSpaceAfterHeader,
    noSpaceAfterHeader = _props$noSpaceAfterHe === void 0 ? defaultProps.noSpaceAfterHeader : _props$noSpaceAfterHe,
    _props$descriptionFon = props.descriptionFont,
    descriptionFont = _props$descriptionFon === void 0 ? defaultProps.descriptionFont : _props$descriptionFon,
    _props$withBorder = props.withBorder,
    withBorder = _props$withBorder === void 0 ? defaultProps.withBorder : _props$withBorder,
    _props$titleColor = props.titleColor,
    titleColor = _props$titleColor === void 0 ? defaultProps.titleColor : _props$titleColor,
    _props$descriptionCol = props.descriptionColor,
    descriptionColor = _props$descriptionCol === void 0 ? defaultProps.descriptionColor : _props$descriptionCol,
    _props$bottomBorderCo = props.bottomBorderColor,
    bottomBorderColor = _props$bottomBorderCo === void 0 ? defaultProps.bottomBorderColor : _props$bottomBorderCo,
    additionalBlock = props.additionalBlock,
    mobileLinkButton = props.mobileLinkButton,
    _props$withContainer = props.withContainer,
    withContainer = _props$withContainer === void 0 ? defaultProps.withContainer : _props$withContainer;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var border = {
    borderBottomWidth: description ? "2px" : 0,
    borderBottomStyle: "solid",
    borderBottomColor: bottomBorderColor
  };
  var headerContent = __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: _objectSpread({
      textAlign: centeredTitle ? "center" : ["center", null, "left"],
      display: additionalBlock ? "flex" : description ? "inline-block" : "block",
      justifyContent: "space-between",
      font: headerFont,
      mb: description || noSpaceAfterHeader ? 0 : link ? ["200px"] : ["s8", null, null, "s10", null, null],
      pr: description ? [0, null, "s13"] : 0,
      pb: description ? "s5" : 0,
      pl: headerIndent,
      color: titleColor
    }, withBorder && border),
    as: titleAs
  }, additionalBlock ? __jsx(_Box["default"], null, title) : title, additionalBlock && __jsx(_Box["default"], null, additionalBlock)), description && __jsx(_Box["default"], {
    sx: {
      font: descriptionFont,
      color: descriptionColor,
      mb: "s10",
      mt: "s5"
    }
  }, description), link && __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: "s_sans",
      mt: noSpaceAfterHeader ? "s5" : 0,
      mb: ["s8", null, null, "s10", null, null],
      color: "main",
      textDecoration: "underline",
      cursor: "pointer"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: {
      url: (link === null || link === void 0 ? void 0 : link.url.indexOf("/")) === 0 ? link.url.replace("/", "") : link.url
    }
  }, __jsx(_LinkRaw["default"], {
    title: link.name
  }, link.name))));
  return withContainer ? __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Container["default"], null, headerContent), children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "") : __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, headerContent, " ", children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "");
};
var _default = SectionWithConfigurableHeader;
exports.Z = _default;

/***/ }),

/***/ 39317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[article]",
      function () {
        return __webpack_require__(16396);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_CardsSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53680);
/* harmony import */ var _deosite_components_new_buttons_ButtonArrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50444);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CardsSlider = function(props) {
    var propsExt = _objectSpread({}, props, {
        buttonArrowLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonArrow__WEBPACK_IMPORTED_MODULE_3__.ButtonArrowLeft, {}),
        buttonArrowRight: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonArrow__WEBPACK_IMPORTED_MODULE_3__.ButtonArrowRight, {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_CardsSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["Z"] = (CardsSlider);


/***/ }),

/***/ 91993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_InfluencerBio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11316);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InfluencerBio = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_InfluencerBio__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (InfluencerBio);


/***/ }),

/***/ 39125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MetaTags; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../components-new/dist/MetaTags/index.js
var MetaTags = __webpack_require__(36880);
;// CONCATENATED MODULE: ./conf/lang.domains.json
var lang_domains_namespaceObject = JSON.parse('{"dajar.cz":"cz","dajar.de":"de","dajar.es":"es","dajar.fr":"fr","dajar.pl":"pl","dajar.it":"it","dajar.co.uk":"gb","dajar.ro":"ro","dajar.se":"se","dajar.sk":"sk"}');
;// CONCATENATED MODULE: ./src/components/MetaTags/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MetaTags_MetaTags = function(props) {
    var propsExt = _objectSpread({}, props, {
        domains: lang_domains_namespaceObject
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.ZP, _objectSpread({}, propsExt)));
};
/* harmony default export */ var components_MetaTags = (MetaTags_MetaTags);


/***/ }),

/***/ 16396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _article_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94986);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ./src/globals.js
var globals = __webpack_require__(88084);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../../node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(56410);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../components-new/dist/Image/index.js
var Image = __webpack_require__(90451);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ./src/containers/UI/PageContainer/index.js + 2 modules
var PageContainer = __webpack_require__(73764);
// EXTERNAL MODULE: ./src/components/ProductBox/index.js
var ProductBox = __webpack_require__(87122);
// EXTERNAL MODULE: ./src/components/CardsSlider/index.js
var CardsSlider = __webpack_require__(75561);
// EXTERNAL MODULE: ../components-new/dist/ArticleHeader/index.js
var ArticleHeader = __webpack_require__(44997);
;// CONCATENATED MODULE: ./src/components/ArticleHeader/index.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ArticleHeader_ArticleHeader = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ArticleHeader/* default */.Z, _objectSpread({}, props));
};
/* harmony default export */ var components_ArticleHeader = (ArticleHeader_ArticleHeader);

// EXTERNAL MODULE: ./src/components/InfluencerBio/index.js
var InfluencerBio = __webpack_require__(91993);
// EXTERNAL MODULE: ../components-new/dist/RelatedStory/index.js
var RelatedStory = __webpack_require__(18799);
;// CONCATENATED MODULE: ./src/components/RelatedStory/index.js



function RelatedStory_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RelatedStory_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RelatedStory_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RelatedStory_RelatedStory = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RelatedStory/* default */.Z, RelatedStory_objectSpread({}, props));
};
/* harmony default export */ var components_RelatedStory = (RelatedStory_RelatedStory);

// EXTERNAL MODULE: ./src/sections/SectionWithConfigurableHeader/index.js
var SectionWithConfigurableHeader = __webpack_require__(44553);
// EXTERNAL MODULE: ./src/sections/Grid2Cards/index.js
var Grid2Cards = __webpack_require__(90485);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismic/index.js
var usePrismic = __webpack_require__(22686);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Grid/index.js
var Grid = __webpack_require__(98290);
var Grid_default = /*#__PURE__*/__webpack_require__.n(Grid);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(53746);
// EXTERNAL MODULE: ./src/components/MetaTags/index.js + 1 modules
var MetaTags = __webpack_require__(39125);
;// CONCATENATED MODULE: ./src/pages/article/[article].js





















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var IMAGE_FULL_WIDTH = "full width";
var IMAGE_WITH_MARGIN = "width with margin";
var IMAGE_WITH_LARGER_MARGIN = "width with larger margin";
var ArticlePage = function(props) {
    var ref, ref1;
    var initialPrismicResponse = props.initialPrismicResponse, initialArticleUid = props.initialArticleUid, lang = props.lang;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,usePrismic/* usePrismic */.xD)("article", initialArticleUid, lang, initialPrismicResponse), prismicResponse = ref2.data;
    var article1 = prismicResponse === null || prismicResponse === void 0 ? void 0 : (ref = prismicResponse.content) === null || ref === void 0 ? void 0 : ref.article;
    var influencerData = (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.blogger) && prismicResponse.blogger[0];
    var relatedArticles = prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.related;
    var translations = {
        shopStory: (0,langLibrary["default"])("Shop this story"),
        seoDescription: (0,langLibrary["default"])("Default seo description"),
        seoTitle: (0,langLibrary["default"])("Default seo title"),
        relatedStories: (0,langLibrary["default"])("Related stories"),
        inspiration: (0,langLibrary["default"])("Inspirations")
    };
    var backLabel = translations.inspiration;
    var backClickFunction = function() {
        router.push("/inspirations", "/inspirations", {
            shallow: true
        });
    };
    var shopArticleSection = /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
        children: (prismicResponse === null || prismicResponse === void 0 ? void 0 : (ref1 = prismicResponse.products) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
            sx: {
                my: "s12",
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                    as: "h5",
                    sx: {
                        font: "label2",
                        mb: "s9",
                        textAlign: "center",
                        color: "main"
                    },
                    children: translations.shopStory
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider/* default */.Z, {
                    children: prismicResponse.products.map(function(product, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductBox/* default */.Z, {
                            product: product
                        }, index);
                    })
                })
            ]
        })
    });
    var simulateImageModes = function(mode, image) {
        switch(mode){
            case IMAGE_FULL_WIDTH:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                    image: image
                }));
            case IMAGE_WITH_MARGIN:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Grid_default()), {
                        cols: [
                            24,
                            null,
                            20,
                            null
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                            sx: {
                                gridColumn: [
                                    "3 / span 20",
                                    null,
                                    "6 / span 10",
                                    null
                                ]
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                                image: image,
                                sizes: "(min-width: 960px) 768px, (max-width: 960px) and (min-width:730px) 420px, (max-width: 730px) and (min-width: 560px) 768px,  (max-width: 560px) and (min-width: 10px) 420px"
                            })
                        })
                    })
                }));
            case IMAGE_WITH_LARGER_MARGIN:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Grid_default()), {
                        cols: [
                            1,
                            null,
                            20,
                            null
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                            sx: {
                                gridColumn: [
                                    "span 1",
                                    null,
                                    "3 / span 16",
                                    null
                                ]
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                                image: image,
                                sizes: "(min-width: 1520px) 1024px, (min-width: 1086px) 768px, (max-width: 1085px) and (min-width: 460px) 420px, (max-width: 460px) and (min-width: 10px) 210px, 1024px"
                            })
                        })
                    })
                }));
            default:
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Image["default"], {
                    image: image
                }));
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                description: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.seoDescription) ? prismicResponse.seoDescription : translations.seoDescription,
                title: (prismicResponse === null || prismicResponse === void 0 ? void 0 : prismicResponse.seoTitle) ? prismicResponse.seoTitle : translations.seoTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* default */.Z, {
                footerContent: props.footerContent,
                returnLinkLabel: backLabel,
                onReturnLabelClick: backClickFunction,
                dataRequiredToHideLoader: [
                    prismicResponse
                ],
                children: [
                    article1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                        sx: {
                            mt: "s10"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticleHeader, {
                                title: article1.title,
                                subtitle: article1.subtitle,
                                influencerData: influencerData
                            }),
                            article1.content && article1.content.map(function(element, index) {
                                if (element.type === "image") {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                                        sx: {
                                            mb: "s10"
                                        },
                                        children: [
                                            index === 3 && shopArticleSection,
                                            simulateImageModes(element.mode, element.image)
                                        ]
                                    }, index));
                                }
                                if (element.type === "text") {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)((Box_default()), {
                                        children: [
                                            index === 3 && shopArticleSection,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                                                sx: {
                                                    mb: "s10",
                                                    font: "body",
                                                    textAlign: "left",
                                                    color: "main"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Grid_default()), {
                                                    cols: [
                                                        1,
                                                        null,
                                                        20,
                                                        null
                                                    ],
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                                        sx: {
                                                            gridColumn: [
                                                                "span 1",
                                                                null,
                                                                "6 / span 10",
                                                                null
                                                            ],
                                                            a: {
                                                                color: "main"
                                                            }
                                                        },
                                                        children: prismic_reactjs.RichText.render(element.text)
                                                    })
                                                })
                                            })
                                        ]
                                    }, index));
                                }
                            })
                        ]
                    }),
                    influencerData && /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Container_default()), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Grid_default()), {
                                cols: [
                                    1,
                                    null,
                                    20,
                                    null
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        gridColumn: [
                                            "span 1",
                                            null,
                                            "6 / span 10",
                                            null
                                        ]
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfluencerBio/* default */.Z, {
                                        influencerData: influencerData
                                    })
                                })
                            })
                        })
                    }),
                    (relatedArticles === null || relatedArticles === void 0 ? void 0 : relatedArticles.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                        title: translations.relatedStories,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2Cards/* default */.Z, {
                            children: relatedArticles.map(function(article, index) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RelatedStory, {
                                        title: article.title,
                                        description: article.description,
                                        route: article.route,
                                        image: article.image
                                    })
                                }, index));
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
ArticlePage.getInitialPropsImmediate = function(props) {};
ArticlePage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(props) {
        var articleUid, language, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    articleUid = props.query.article;
                    language = props.language;
                    _ctx.next = 5;
                    return (0,usePrismic/* fetcher */._i)("article", articleUid, language);
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", {
                        initialPrismicResponse: response,
                        initialArticleUid: articleUid,
                        lang: language
                    });
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", _ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function(props) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ var _article_ = (ArticlePage);


/***/ }),

/***/ 90485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_Grid2Cards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66836);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Grid2Cards = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_Grid2Cards__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Grid2Cards);


/***/ }),

/***/ 44553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88778);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SectionWithConfigurableHeader = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionWithConfigurableHeader);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [902,9774,2888,179], function() { return __webpack_exec__(39317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);